import React, { useEffect, useState } from 'react';
import {
    Box, TextField, Button, Typography, Stack, MenuItem
} from '@mui/material';
import axios from 'axios';

const BuildingDetailsWallsAddWall = ({ buildingId, wall, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        area: '',
        orientation: '',
        shading: '',
        u_value: '',
        u_value_uninsulated: ''
    });

    useEffect(() => {
        if (wall) {
            setFormData({
                name: wall.name,
                area: wall.area,
                orientation: wall.orientation,
                shading: wall.shading,
                u_value: wall.u_value,
                u_value_uninsulated: wall.u_value_uninsulated
            });
        }
    }, [wall]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            area: parseFloat(formData.area),
            u_value: parseFloat(formData.u_value),
            u_value_uninsulated: parseFloat(formData.u_value_uninsulated),
            building: parseInt(buildingId)
        };

        const request = wall
            ? axios.put(`/buildings/${buildingId}/walls/${wall.id}/`, payload)
            : axios.post(`/buildings/${buildingId}/walls/`, payload);

        request
            .then(() => {
                onSuccess();
                onClose();
            })
            .catch(() => {
                onError();
            });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2, width: 400 }}>
            <Typography variant="h6" gutterBottom mb={2}>{wall ? 'Edit Wall' : 'Add New Wall'}</Typography>
            <Stack spacing={2}>
                <TextField
                    name="name"
                    label="Name"
                    required
                    fullWidth
                    value={formData.name}
                    onChange={handleChange}
                />
                <TextField
                    name="area"
                    label="Area"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    required
                    fullWidth
                    value={formData.area}
                    onChange={handleChange}
                />
                <TextField
                    name="orientation"
                    label="Orientation"
                    select
                    required
                    fullWidth
                    value={formData.orientation}
                    onChange={handleChange}
                >
                    {['North', 'South', 'East', 'West'].map((opt) => (
                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                    ))}
                </TextField>
                <TextField
                    name="shading"
                    label="Shading"
                    select
                    required
                    fullWidth
                    value={formData.shading}
                    onChange={handleChange}
                >
                    {['Low', 'Medium', 'High'].map((opt) => (
                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                    ))}
                </TextField>
                <TextField
                    name="u_value"
                    label="U-Value (Insulated)"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    required
                    fullWidth
                    value={formData.u_value}
                    onChange={handleChange}
                />
                <TextField
                    name="u_value_uninsulated"
                    label="U-Value (Uninsulated)"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    required
                    fullWidth
                    value={formData.u_value_uninsulated}
                    onChange={handleChange}
                />
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button onClick={onClose} variant="outlined" color="secondary">Cancel</Button>
                    <Button type="submit" variant="contained">{wall ? 'Update Wall' : 'Add Wall'}</Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BuildingDetailsWallsAddWall;
